import { render } from "./Templates.vue?vue&type=template&id=4ed35cbe&scoped=true"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"

import "./Templates.vue?vue&type=style&index=0&id=4ed35cbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed35cbe"]])

export default __exports__